import logo from './logo.png';
import { useLoading } from "./script";
export const LoadingModal = () => {
    const {loading} = useLoading();
    return loading && <div style={{backgroundColor: "#FAFAFA", opacity: 0.8, width: "100vw", height: "100vh", overflow:"hidden", position: "absolute", top: 0, left: 0, zIndex: 1000}}>
        <img src={logo} alt="Логотип" style={{position: "absolute", top: "50%", left: "50%",  transform: "translate(-50%, -50%)"}} />
    </div> 
}